import { FormControlLabel, Switch } from '@mui/material';
import { useLocales } from 'src/locales';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

export const ToggleAudioNoiseFilter = () => {
  const { translate } = useLocales();
  const { noiseFilter, setNoiseFilter } = useLivekitRTCState();

  return (
    <FormControlLabel
      control={
        <Switch
          checked={noiseFilter}
          onChange={(e, value) => setNoiseFilter(value)}
        />
      }
      label={translate('communicate.rtc_controls.toggle_noise_filter')}
      sx={{ m: 0 }}
    />
  );
};
